"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactFinalForm = require("react-final-form");
var _reactFinalFormArrays = require("react-final-form-arrays");
var _finalFormArrays = _interopRequireDefault(require("final-form-arrays"));
var _ActionListFieldArray = _interopRequireDefault(require("./ActionListFieldArray"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const propTypes = {
  actionAssigner: _propTypes.default.func,
  columnMapping: _propTypes.default.object,
  contentData: _propTypes.default.arrayOf(_propTypes.default.object),
  creatableFields: _propTypes.default.object,
  createCallback: _propTypes.default.func,
  defaultNewObject: _propTypes.default.object,
  editableFields: _propTypes.default.object,
  fieldComponents: _propTypes.default.object,
  hideActionsColumn: _propTypes.default.bool,
  hideCreateButton: _propTypes.default.bool,
  intlKey: _propTypes.default.string,
  intlNS: _propTypes.default.string,
  label: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.node]),
  labelOverrides: _propTypes.default.object,
  validateFields: _propTypes.default.object,
  visibleFields: _propTypes.default.arrayOf(_propTypes.default.string)
};
const ActionList = /*#__PURE__*/(0, _react.forwardRef)((_ref, ref) => {
  let {
    actionAssigner,
    columnMapping,
    contentData,
    creatableFields = {},
    createCallback,
    defaultNewObject = {},
    editableFields = {},
    fieldComponents = {},
    hideActionsColumn = false,
    hideCreateButton,
    intlKey: passedIntlKey,
    intlNS: passedIntlNS,
    label,
    labelOverrides = {},
    validateFields,
    visibleFields,
    ...mclProps // Assume anything left over is to directly apply to the MCL
  } = _ref;
  const ActionListFieldArrayWithRef = alfaProps => /*#__PURE__*/(0, _jsxRuntime.jsx)(_ActionListFieldArray.default, {
    ref: ref,
    ...alfaProps
  });
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactFinalForm.Form, {
      enableReinitialize: true,
      initialValues: {
        contentData
      },
      mutators: _finalFormArrays.default,
      onSubmit: () => null,
      subscription: {
        contentData: true
      },
      children: _ref2 => {
        let {
          handleSubmit
        } = _ref2;
        return /*#__PURE__*/(0, _jsxRuntime.jsx)("form", {
          onSubmit: e => {
            e.preventDefault();
          },
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactFinalFormArrays.FieldArray, {
            actionAssigner: actionAssigner,
            columnMapping: columnMapping,
            component: ActionListFieldArrayWithRef,
            creatableFields: creatableFields,
            createCallback: createCallback,
            defaultNewObject: defaultNewObject,
            editableFields: editableFields,
            fieldComponents: fieldComponents,
            hideActionsColumn: hideActionsColumn,
            hideCreateButton: hideCreateButton,
            intlKey: passedIntlKey,
            intlNS: passedIntlNS,
            label: label,
            labelOverrides: labelOverrides,
            name: "contentData",
            triggerFormSubmit: handleSubmit,
            validateFields: validateFields,
            visibleFields: visibleFields,
            ...mclProps
          })
        });
      }
    })
  });
});
ActionList.propTypes = propTypes;
var _default = exports.default = ActionList;